export default __webpack_public_path__ + "static/media/github-1.e9c54a0e.png";